import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { CATS, STATUS, label } from "@/lib/adopt";

const Stats = () => {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/admin/adopcion-stats").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2" data-testid="admin-adopt-stats">
      {[["pendiente", "En revisión"], ["publicado", "Publicados"], ["pausado", "Pausados"], ["adoptado", "Adoptados"], ["rechazado", "Rechazados"], ["solicitudes", "Solicitudes"], ["denuncias", "Denuncias"], ["anunciantes", "Anunciantes"]].map(([k, l]) => (
        <div key={k} className="bg-[#FFF8F0] rounded p-3"><p className="text-xs text-slate-500">{l}</p><p className="text-2xl font-black text-[#3D405B]" data-testid={`admin-adopt-stat-${k}`}>{s[k]}</p></div>
      ))}
    </div>
  );
};

const Reports = ({ onChange }) => {
  const [rows, setRows] = useState([]);
  const load = () => api.get("/admin/adopcion-denuncias").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);
  if (!rows.length) return <p className="text-sm text-slate-500">No hay denuncias abiertas.</p>;
  return (
    <ul className="divide-y" data-testid="admin-adopt-reports">
      {rows.map((r) => (
        <li key={r.id} className="py-2 flex flex-wrap items-center justify-between gap-2 text-sm">
          <span><Link to={`/adopcion/${r.adoption_id}`} className="font-bold text-[#2563EB]">{r.title}</Link> · {r.reason}{r.text && ` · «${r.text}»`}</span>
          <button onClick={async () => { await api.post(`/admin/adopcion-denuncias/${r.id}/cerrar`); load(); onChange(); }} className="text-xs font-bold border rounded-full px-3 py-1" data-testid={`admin-report-close-${r.id}`}>Marcar revisada</button>
        </li>
      ))}
    </ul>
  );
};

export const AdminAdoption = () => {
  const [status, setStatus] = useState("pendiente");
  const [rows, setRows] = useState([]);
  const [k, setK] = useState(0);
  const load = () => api.get("/admin/adopciones", { params: { status } }).then((r) => setRows(r.data));
  useEffect(() => { load(); }, [status, k]); // eslint-disable-line react-hooks/exhaustive-deps
  const moderate = async (id, action) => {
    const note = action === "rechazar" ? window.prompt("Motivo del rechazo (lo verá el anunciante):", "No cumple las normas de adopción responsable") : "";
    if (note === null) return;
    try { await api.post(`/admin/adopciones/${id}/moderar`, { action, note }); toast.success(action === "aprobar" ? "Publicado" : "Rechazado"); setK(k + 1); } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div className="space-y-8" data-testid="admin-adoption">
      <Stats key={k} />
      <div>
        <div className="flex flex-wrap gap-2 mb-4">
          {Object.entries(STATUS).map(([s, l]) => <button key={s} onClick={() => setStatus(s)} className={`text-sm font-bold px-3 py-1.5 rounded-full border ${status === s ? "bg-[#3D405B] text-white" : ""}`} data-testid={`admin-adopt-filter-${s}`}>{l}</button>)}
        </div>
        {!rows.length && <p className="text-sm text-slate-500" data-testid="admin-adopt-empty">No hay anuncios en este estado.</p>}
        <div className="space-y-3">
          {rows.map((x) => (
            <div key={x.id} className="border rounded p-4 flex flex-wrap items-start justify-between gap-3" data-testid={`admin-adopt-${x.id}`}>
              <div className="text-sm max-w-2xl">
                <Link to={`/adopcion/${x.id}`} className="font-bold text-[#2563EB] text-base">{x.name ? `${x.name} · ` : ""}{x.title}</Link>
                <p className="text-slate-600">{label(CATS, x.category)} · {x.species} {x.breed} · {x.city} ({x.province}) · {x.email} · {x.photo_count} fotos{x.reports > 0 && <b className="text-red-600"> · {x.reports} denuncias</b>}</p>
                <p className="text-slate-700 mt-1 line-clamp-2">{x.about}</p>
              </div>
              <div className="flex gap-2">
                {["pendiente", "rechazado"].includes(x.status) && <button onClick={() => moderate(x.id, "aprobar")} className="bg-emerald-600 text-white text-sm font-bold rounded-full px-4 py-2" data-testid={`admin-adopt-approve-${x.id}`}>Aprobar</button>}
                {x.status !== "rechazado" && <button onClick={() => moderate(x.id, "rechazar")} className="bg-red-600 text-white text-sm font-bold rounded-full px-4 py-2" data-testid={`admin-adopt-reject-${x.id}`}>Rechazar</button>}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div><h3 className="font-bold text-lg mb-2">Denuncias abiertas</h3><Reports onChange={() => setK(k + 1)} /></div>
    </div>
  );
};
